import React from 'react';
import { CheckCircle } from 'lucide-react';

// Peoria Charter submission confirmation card. Shown after the rider approves the estimate and we
// send the lead to the Peoria Charter team — a visual "done" instead of a plain text line. Reuses the
// CharterQuoteCard container styling with a success left-border + a check icon.

export function ConfirmationCard({ data }) {
  const title = data.title || 'Sent to the Peoria Charter team';
  const message =
    data.message ||
    "Your request is in. A Peoria Charter rep will review the quote and email you shortly to firm up the details.";
  return (
    <div className="bg-peoria-surface border border-peoria-border border-l-4 border-l-green-500 rounded-card p-5 my-2">
      <div className="flex items-start gap-3">
        <CheckCircle className="w-5 h-5 text-green-700 shrink-0 mt-0.5" />
        <div>
          <div className="text-base font-semibold text-peoria-text">{title}</div>
          <p className="text-13 text-peoria-muted mt-1 leading-relaxed">{message}</p>
          {data.quoteNumber && (
            <p className="text-11 text-peoria-muted mt-2 font-mono">Quote {data.quoteNumber}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ConfirmationCard;
